export const DateTimeConfiguration = {
  en: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    detailed: {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
    plain: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
  },
  de: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: "Europe/Berlin",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: "Europe/Berlin",
    },
    detailed: {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZone: "Europe/Berlin",
    },
    plain: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
  },
};

export default {
  supportedLanguages: ["en", "de"],
  fallbackLocale: "de",
  locale: "de",
  datetimeFormats: DateTimeConfiguration,
};
